import ConsentText from './ConsentText';

export default ConsentText;
